var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacthover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.35,
    height: 16.8,
    viewBox: "0 0 21.35 16.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Contacts",
    transform: "translate(-1100 -3774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_8",
    "data-name": "Line 8",
    d: "M14,.85H0A.85.85,0,0,1-.85,0,.85.85,0,0,1,0-.85H14a.85.85,0,0,1,.85.85A.85.85,0,0,1,14,.85Z",
    transform: "translate(1106.5 3775.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M14,.85H0A.85.85,0,0,1-.85,0,.85.85,0,0,1,0-.85H14a.85.85,0,0,1,.85.85A.85.85,0,0,1,14,.85Z",
    transform: "translate(1106.5 3782.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M14,.85H0A.85.85,0,0,1-.85,0,.85.85,0,0,1,0-.85H14a.85.85,0,0,1,.85.85A.85.85,0,0,1,14,.85Z",
    transform: "translate(1106.5 3789.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "translate(1100 3774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "translate(1100 3781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 1.4,
    cy: 1.4,
    r: 1.4,
    transform: "translate(1100 3788)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacthover);
export default __webpack_public_path__ + "static/media/Contacthover.be398c377f029b995792644c70c8f4eb.svg";
export { ForwardRef as ReactComponent };